"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeNativePermissionStatus = exports.normalizeNativeMessage = void 0;
var normalizeNativeMessage_1 = require("./normalizeNativeMessage");
Object.defineProperty(exports, "normalizeNativeMessage", { enumerable: true, get: function () { return normalizeNativeMessage_1.normalizeNativeMessage; } });
var normalizeNativePermissionStatus_1 = require("./normalizeNativePermissionStatus");
Object.defineProperty(exports, "normalizeNativePermissionStatus", { enumerable: true, get: function () { return normalizeNativePermissionStatus_1.normalizeNativePermissionStatus; } });
